// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__vLvqf","title":"Widget_title__LHeb+"};